import { render, staticRenderFns } from "./UnidadesNegocio.vue?vue&type=template&id=b8345282&"
import script from "./UnidadesNegocio.vue?vue&type=script&lang=js&"
export * from "./UnidadesNegocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports